import { useState } from 'react'
import { TabNav } from '../../components/nav/tabNav'
import { PageHeader } from '../../components/typography/PageHeader'
import { usePermissions } from '../../hooks/usePermissions'
import Layout from '../../layout'
import { DiscoverCards } from './discover-cards'
import { FeedWeightsSettings, ImpressionReport } from './discover-settings'

export function DiscoverFeedPage() {
  const { hasPermissions } = usePermissions()
  const canEdit = hasPermissions(['update_system_settings'])
  const canReport = hasPermissions(['export_reports'])
  const [activeTab, setActiveTab] = useState(canEdit ? 'cards' : 'analytics')
  const tabs = [
    ...(canEdit
      ? [
          { id: 'cards', name: 'Feed cards' },
          { id: 'ranking', name: 'Ranking' },
        ]
      : []),
    ...(canReport ? [{ id: 'analytics', name: 'Impressions' }] : []),
  ]
  return (
    <Layout>
      <PageHeader title="Discover" />
      <p className="mb-6 text-sec-black">
        Build cards from your products, creators and experiences. Each
        customer’s interests shape what they discover.
      </p>
      <TabNav
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        className="mb-8"
      />
      {canEdit && activeTab === 'cards' && <DiscoverCards />}
      {canEdit && activeTab === 'ranking' && <FeedWeightsSettings />}
      {canReport && activeTab === 'analytics' && <ImpressionReport />}
    </Layout>
  )
}
